import { TextMode } from "@plansoft-configuration-renderer/framework";
export const INFO_LAYOUT_PROPS_DEFAULTS = {
    textMode: TextMode.Markdown,
    overlayMode: "popover",
};
//# sourceMappingURL=Info.defaults.js.map